<template>
  <b-card v-if="conformitaUser" no-body class="phone-card">
    <b-card-header class="phone-header">
      <div class="header-title">
        <i class="fas fa-phone mr-2"></i>
        <strong>Canal Telefônico</strong>
      </div>
      <div class="header-actions">
        <b-button
          v-if="!isConcluded && !complaint.phoneServiceProtocol"
          variant="primary"
          size="sm"
          :disabled="!phoneServiceProtocol"
          @click="$emit('associate')"
          >Associar
        </b-button>
        <b-button
          v-if="oldPhoneServiceProtocol"
          variant="secondary"
          size="sm"
          @click="$emit('cancel-replace')"
        >
          Cancelar
        </b-button>
        <b-button
          v-if="canEdit && complaint.phoneServiceProtocol"
          variant="primary"
          size="sm"
          @click="$emit('replace')"
          >Editar</b-button
        >
      </div>
    </b-card-header>

    <template v-if="!complaint.phoneServiceProtocol">
      <b-form-group label="Protocolo Telefônico">
        <b-form-input
          :value="phoneServiceProtocol"
          :disabled="isConcluded"
          type="text"
          class="form-control"
          @input="$emit('update:phoneServiceProtocol', $event)"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Data efetiva de recebimento">
        <b-row no-gutters>
          <b-col cols="6">
            <b-form-input
              :value="phoneServiceReceiveDate"
              :disabled="isConcluded"
              type="date"
              class="form-control"
              @input="$emit('update:phoneServiceReceiveDate', $event)"
            ></b-form-input>
          </b-col>
          <b-col cols="6">
            <b-form-input
              :value="phoneServiceReceiveTime"
              :disabled="isConcluded"
              type="time"
              class="form-control"
              @input="$emit('update:phoneServiceReceiveTime', $event)"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
    </template>
    <template v-else>
      <b-form-group label="Protocolo Telefônico">
        <b-form-input
          type="text"
          class="form-control"
          disabled
          :value="complaint.phoneServiceProtocol"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Data efetiva de recebimento">
        <b-row no-gutters>
          <b-col cols="6">
            <b-form-input
              type="date"
              class="form-control"
              :value="
                moment(complaint.phoneServiceReceiveDate).format('YYYY-MM-DD')
              "
              disabled
            ></b-form-input>
          </b-col>
          <b-col cols="6">
            <b-form-input
              type="time"
              class="form-control"
              :value="moment(complaint.phoneServiceReceiveDate).format('HH:mm')"
              disabled
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
    </template>
  </b-card>
</template>

<script>
import ComplaintStatus from "../../../../../backend/models/ComplaintStatus.ts";
import moment from "moment/moment";

export default {
  name: "PhoneCard",
  props: {
    complaint: { type: Object, required: true },
    canEdit: { type: Boolean, default: false },
    conformitaUser: { type: Boolean, default: false },
    phoneServiceProtocol: { type: String, default: null },
    phoneServiceReceiveDate: { type: String, default: null },
    phoneServiceReceiveTime: { type: String, default: null },
    oldPhoneServiceProtocol: { type: String, default: null },
  },
  data() {
    return { moment };
  },
  computed: {
    isConcluded() {
      return this.complaint.status === ComplaintStatus.CONCLUDED;
    },
  },
};
</script>

<style></style>
